import { Outlet } from "react-router-dom";
import { Flex, ScrollArea, Container } from "@radix-ui/themes";
import { SettingsPageSidebar } from "./SettingsPageSidebar";
import styles from "./SettingsPage.module.scss";

export function SettingsPage() {
  return (
    <Flex className={styles.settingsLayout}>
      <SettingsPageSidebar />

      <Flex className={styles.mainContent} direction="column">
        <ScrollArea className={styles.contentArea}>
          <div className={styles.content}>
            <Container size="4">
              <Outlet />
            </Container>
          </div>
        </ScrollArea>
      </Flex>
    </Flex>
  );
}
